import { useCallback, useEffect, useState } from "react";
import { Toast } from "@/shared/components/feedback/Toast";
import { onAppLinkNotice } from "@/shared/utils/appLinks";

/** Shows failures from opening our own links (see showAppLinkNotice). Mounted once in AppLayout. */
export const AppLinkNotice = () => {
  const [message, setMessage] = useState("");
  const clear = useCallback(() => setMessage(""), []);

  useEffect(() => onAppLinkNotice(setMessage), []);

  if (!message) return null;
  return <Toast key={message} message={message} type="error" duration={5000} onClose={clear} />;
};
